// 每个 WebView 独立保存；原生覆盖首页时，路由和 visibilityState 可能都不变。
let homePopupsSuspended = false

export const suspendHomePopups = () => {
  homePopupsSuspended = true
}

export const resumeHomePopups = (event: Event) => {
  if (event.isTrusted && window.location.pathname === '/m/home') {
    homePopupsSuspended = false
  }
}

export const canOpenHomePopup = () => {
  return !homePopupsSuspended &&
    window.location.pathname === '/m/home' &&
    document.visibilityState === 'visible'
}
